// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1757":"1ddd7e97","2729":"20e25ed1","3138":"e432fe9c","4579":"9c6c3425","8199":"20e25ed1"}[chunkId] + ".chunk.css";
};